export type MountWithLkidParams = {
  href?: string;
  lkid?: string;
};

export function mountWithLkid({ href, lkid }: MountWithLkidParams) {
  if (!href) return undefined;
  if (!lkid) return href;
  
  const url = new URL(href);

  url.searchParams.set("lkid", lkid);

  return url.toString();
}
